module.exports = __webpack_public_path__ + "static/turquia-020.thumb-e70b9cebfc935d1fb3116b59796ce670.jpg";